import { useMemo } from 'react';

export const useSkipToLink = (elementId: string, label: string) =>
  useMemo(
    () => ({
      href: `#${elementId}`,
      label,
    }),
    [elementId, label]
  );
